import * as React from 'react';
import Bs4MainDispatch from './Bs4MainDispatch';
import * as Bs4Utils from './Bs4Components/Bs4Utils'
import {EventEmit} from './Bs4Components/Bs4Utils'

export default class Bs4I18N {    
  static BS4I18N_SETTOPHRASE = 'Bs4I18N_setToPhrase';
  static BS4I18N_TOPHRASE = 'Bs4I18N_ToPhrase'
  static toPhrase = {};
  static okPhrase = {};
  static noPhrase = {};
  static eventEmit = new EventEmit();

  static bs4ConstructorMode = false;

  static restoreToPhrase() {    
    try {
      Bs4I18N.setToPhrase(JSON.parse(window.localStorage.getItem(Bs4I18N.BS4I18N_TOPHRASE)));
    } catch (error) {}
  }

  static setToPhrase(value) {        
    if (value && typeof value === 'object' && !Array.isArray(value) && !(typeof value === 'string' || value instanceof String)) {
      Bs4I18N.toPhrase = value;
      Bs4I18N.okPhrase = {};
      for (let [key, value] of Object.entries(Bs4I18N.noPhrase)) {
        if (key in Bs4I18N.toPhrase) delete Bs4I18N.noPhrase[key];
      }
    }
    window.localStorage.setItem(Bs4I18N.BS4I18N_TOPHRASE, JSON.stringify(Bs4I18N.toPhrase));
    // console.log('...Bs4I18N.setToPhrase...', value);
    Bs4I18N.eventEmit.trigger(Bs4I18N.BS4I18N_SETTOPHRASE, null);
  }

  static useTT = (key, suggested, comment) => {    
    const [text, setText] = React.useState(this.getTT(key, suggested, comment));
  
    React.useEffect(() => {      
      const updateText = () => {
        // console.log('...Bs4I18N.updateTexts...', key, suggested, comment);
        setText(this.getTT(key, suggested, comment));
      }
      Bs4I18N.eventEmit.on(Bs4I18N.BS4I18N_SETTOPHRASE, updateText);
      return () => Bs4I18N.eventEmit.off(Bs4I18N.BS4I18N_SETTOPHRASE, updateText);
    }, [key, suggested, comment, setText]);
  
    return text;
  }

  static useTTA = (array) => {    
    const [textArray, setTextArray] = React.useState(this.getTTA(array));
  
    React.useEffect(() => {      
      const updateTexts = () => {
        // console.log('...Bs4I18N.updateTexts...', array);
        setTextArray(this.getTTA(array));
      }
      Bs4I18N.eventEmit.on(Bs4I18N.BS4I18N_SETTOPHRASE, updateTexts);
      return () => Bs4I18N.eventEmit.off(Bs4I18N.BS4I18N_SETTOPHRASE, updateTexts);
    }, [array, setTextArray]);
  
    return textArray;
  }

  static getTT = (key, suggested, comment) => {
    // return key;
    const value = Bs4I18N.toPhrase[key]
    if (!value) {
      // console.log('...Bs4I18N...getTT NO...', key, suggested, comment, key in Bs4I18N.noPhrase);
      if (key in Bs4I18N.noPhrase) {
        Bs4I18N.noPhrase[key].count += 1;
      }
      else {
        Bs4I18N.noPhrase[key] = {suggested: suggested, count: 1, comment: comment};
        Bs4I18N.sendBs4LocaleList(key);
      }
      return key;
    }

    if (key in Bs4I18N.okPhrase) Bs4I18N.okPhrase[key].count += 1;
    else Bs4I18N.okPhrase[key] = {translated: value, count: 1, comment: comment};
    return value;
  }

  static getTTA = (array) => array.map(([key, suggested, comment]) => Bs4I18N.getTT(key, suggested, comment));

  static sendBs4LocaleListTimeoutkeys = [];
  static sendBs4LocaleListTimeoutId = null;
  static sendBs4LocaleList = (key) => {
    clearTimeout(Bs4I18N.sendBs4LocaleListTimeoutId);
    Bs4I18N.sendBs4LocaleListTimeoutkeys.push(key)
    Bs4I18N.sendBs4LocaleListTimeoutId = setTimeout(() => {      
      Bs4MainDispatch.commandParser('bs4LocaleList', {locale: Bs4I18N.getLang(), operation: 2, phrases: Bs4I18N.sendBs4LocaleListTimeoutkeys});
      console.log('...Bs4I18N...sendBs4LocaleList...', this.sendBs4LocaleListTimeoutkeys);
      // Bs4MainDispatch.commandParser('bs4LocaleList', {locale: Bs4I18N.getLang(), operation: 2, phrases: noPhrase});
      Bs4I18N.sendBs4LocaleListTimeoutkeys = [];
    }, 1000 * 60);
  }

  //TYLKO W TRYBIE KONSTRUKTOR

  static listnoPhrase() {                
    console.log('=== Bs4I18N ===');
    console.log('=== No phrase:', Object.keys(Bs4I18N.noPhrase));
    console.log('=== To phrase:', Bs4I18N.toPhrase);    
    console.log('=== statistics no phrase:', Bs4I18N.noPhrase);
    console.log('=== statistics to phrase:', Bs4I18N.okPhrase);

    const noPhrase = Object.keys(Bs4I18N.noPhrase);
    if (Bs4I18N.bs4ConstructorMode && noPhrase.length > 0) {      
      Bs4MainDispatch.commandParser('bs4LocaleList', {locale: Bs4I18N.getLang(), operation: 2, phrases: noPhrase});
    }
  }

  static getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  static getLang = () => {
    return Bs4I18N.getCookie('lang') || null;
  }

  static setLang = (lang) => {
    const langStr = lang ? String(lang) : '';
    document.cookie = 'lang='+langStr;
  }
}